import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContentLoadingIndicatorComponent} from './content-loading-indicator.component';


@NgModule({
  declarations: [ContentLoadingIndicatorComponent],
  exports: [ContentLoadingIndicatorComponent],
  imports: [
    CommonModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContentLoadingIndicatorModule {
}
